import {Component, Input, OnInit} from "@angular/core";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {Notification} from "../../../shared/components/notifier/notification";
import {NotifierComponent} from "../../../shared/components/notifier/notifier.component";
import {NotificationType} from "../../../shared/components/notifier/notification-type";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {PaymentMethod} from "../../../user/payment-method";
import {WorkspaceService} from "../../workspace.service";
import { filter, first } from "rxjs";


@Component({
    selector: 'db-change-payment-method',
    templateUrl: './change-payment-method.component.html',
    styleUrls: ['./change-payment-method.component.scss'],
    standalone: false
})
export class ChangePaymentMethodComponent extends DialogComponent<null, boolean> implements OnInit {
  public loading: boolean;

  public title: string;
  public changes: any;
  @Input() paymentMethod: PaymentMethod;
  @Input() changeEvent: string;

  constructor(
    private _workspaceService: WorkspaceService,
    private _dialogService: DialogService,
  ) {
    super(
      _dialogService
    );

  }

  ngOnInit() {
  }


  public changePaymentMethod(paymentMethodId): void {
    this.loading = true;
    this._workspaceService.setActivePaymentMethod(paymentMethodId)
    .pipe(
      filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response): void => {
        this.loading = false;

        if (response.success) {
          this.result = true;
          this.close();
          NotifierComponent.notify(new Notification("Payment method changed.", NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  public changePayPalToCard(paymentMethodId) {
    this.loading = true;
    this._workspaceService.switchPaymentMethod('card', paymentMethodId)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response) => {
        this.loading = false;
        if (response.success) {
          this.result = true;
          this.close();
          NotifierComponent.notify(new Notification("Payment method changed.", NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  public close_window(): void {
    this.close();
  }

}
